<template>
    <v-row no-gutters>
        <v-col cols="12" class="text-center caption">
            Updated {{ timestamp }}
        </v-col>
    </v-row>
</template>

<script>
export default {
  name: "Timestamp",
  props: {
    event: Object,
  },
  computed: {
      timestamp() {
          return moment.tz(this.event.StatusLastUpdate,"UTC").local().fromNow();
      }
  }
};
</script>